__turbopack_context__.v({
  "card": "tableComponent-module-scss-module__dHvAwG__card",
  "cardBody": "tableComponent-module-scss-module__dHvAwG__cardBody",
  "cardHeader": "tableComponent-module-scss-module__dHvAwG__cardHeader",
  "cardLabel": "tableComponent-module-scss-module__dHvAwG__cardLabel",
  "cardRow": "tableComponent-module-scss-module__dHvAwG__cardRow",
  "cardSummary": "tableComponent-module-scss-module__dHvAwG__cardSummary",
  "cardValue": "tableComponent-module-scss-module__dHvAwG__cardValue",
  "cards": "tableComponent-module-scss-module__dHvAwG__cards",
  "description": "tableComponent-module-scss-module__dHvAwG__description",
  "desktopOnly": "tableComponent-module-scss-module__dHvAwG__desktopOnly",
  "mobileOnly": "tableComponent-module-scss-module__dHvAwG__mobileOnly",
  "table": "tableComponent-module-scss-module__dHvAwG__table",
  "tableComponent": "tableComponent-module-scss-module__dHvAwG__tableComponent",
  "tableWrapper": "tableComponent-module-scss-module__dHvAwG__tableWrapper",
  "td": "tableComponent-module-scss-module__dHvAwG__td",
  "tdSummary": "tableComponent-module-scss-module__dHvAwG__tdSummary",
  "th": "tableComponent-module-scss-module__dHvAwG__th",
  "title": "tableComponent-module-scss-module__dHvAwG__title",
  "tr": "tableComponent-module-scss-module__dHvAwG__tr",
  "trSummary": "tableComponent-module-scss-module__dHvAwG__trSummary",
});
